const BASE_ETR = `${BACKOFFICE_API_URL}/trader-bot/etr`
export const STATUS_ETR = `${BASE_ETR}/status`
export const START_ETR = `${BASE_ETR}/start`
export const STOP_ETR = `${BASE_ETR}/stop`

const BASE_ETP = `${BACKOFFICE_API_URL}/trader-bot/etp`
export const STATUS_ETP = `${BASE_ETP}/status`
export const START_ETP = `${BASE_ETP}/start`
export const STOP_ETP = `${BASE_ETP}/stop`
